export default "__VITE_ASSET__ELoN9LW4__"